// src/widgets/StickyNoteWidget.jsx
import { useState } from 'react';
import { StickyNote } from 'lucide-react';

const STICKY_NOTE_KEY = 'overview_sticky_note_v1';

export default function StickyNoteWidget() {
  const [text, setText] = useState(() => {
    try { return localStorage.getItem(STICKY_NOTE_KEY) || ''; }
    catch { return ''; }
  });

  const onChange = (e) => {
    const val = e.target.value;
    setText(val);
    try { localStorage.setItem(STICKY_NOTE_KEY, val); }
    catch { /* ignore */ }
  };

  return (
    <div style={{
      height: '100%',
      boxSizing: 'border-box',
      background: 'var(--bg-card)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-lg)',
      display: 'flex',
      flexDirection: 'column',
      padding: 14,
      gap: 8,
    }}>
      <div style={{
        fontSize: 12,
        fontWeight: 600,
        color: 'var(--text-secondary)',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        flexShrink: 0,
      }}>
        <StickyNote size={13} color="var(--accent-orange)" />
        Sticky Note
      </div>
      <textarea
        value={text}
        onChange={onChange}
        placeholder="Tulis catatan cepat di sini…"
        style={{
          flex: 1,
          width: '100%',
          resize: 'none',
          border: 'none',
          outline: 'none',
          background: 'transparent',
          color: 'var(--text-primary)',
          fontSize: 13,
          fontFamily: 'inherit',
          lineHeight: 1.5,
          boxSizing: 'border-box',
        }}
      />
    </div>
  );
}